<template>
    <div v-if="visible">
        <div class="modal-backdrop">
        </div>
        <div class="modal">
            <div class="modal-header">
                <h4 class="modal-title">{{$t('components.media.restrict-modal.title')}}</h4>
                <button class="btn-close" @click="close">&times;</button>
            </div>
            <div class="modal-body" ref="loadingContainer">
                <div class="row">
                    <div class="col-sm-12 font-weight-bold">
                        {{$t('components.media.restrict-modal.filename')}}
                    </div>
                    <div class="col-sm-12">
                        {{mediaItem.name}}<span v-if="mediaItem.type === 'TYPE_FILE'">.{{mediaItem.extension}}</span>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-sm-12 font-weight-bold">
                        {{$t('components.media.restrict-modal.path')}}
                    </div>
                    <div class="col-sm-12 ">
                        ~/{{mediaItem.path}}
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-sm-12 font-weight-bold">
                        {{$t('components.media.restrict-modal.restricted')}}
                    </div>
                    <div class="col-sm-12">
                        <select class="form-control form-control-sm" v-model="restricted">
                            <option :value="false">{{$t('confirm.no')}}</option>
                            <option :value="true">{{$t('confirm.yes')}}</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-5" v-if="restricted">
                    <div class="col-sm-12">
                        <MultiSelect v-model="selectedHierarchies" :options="hierarchies"
                                     :placeholder="$t('please-select')"
                                     :multiple="true"
                                     :close-on-select="false"
                                     :clear-on-select="true"
                                     :preserve-search="true"
                                     label="description" track-by="description">
                        </MultiSelect>
                    </div>
                </div>
                <hr class="mt-3 mb-3">
                <div class="row mt-3">
                    <div class="col-sm-12 text-center">
                        <button @click="update" class="btn btn-wellis-gold float-right w-25 text-white">{{$t('btnSave')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MultiSelect from 'vue-multiselect';
import {EVENT_MEDIA_RESTRICT_CHANGED, EVENT_MEDIA_RESTRICT_CLOSE} from "@/core/constants";
import {empty} from "@/helpers";
import MediaApiService from "@/api/media.api";

export default {
    name: "MediaItemRestriction",
    components: {MultiSelect},
    props: {
        visible: Boolean,
        mediaItem: Object
    },

    data() {
        return {
            restricted: false,
            hierarchies: [],
            selectedHierarchies: [],
            loader: null,
        }
    },

    methods: {
        close() {
            this.$eventBus.$emit(EVENT_MEDIA_RESTRICT_CLOSE);
        },

        fetch() {
            this.showLoader();
            MediaApiService.permissions(this.mediaItem.path)
                .then(response => {
                    this.hierarchies = response.data.hierarchies;
                    this.restricted = response.data.restricted;
                    this.selectedHierarchies = [];
                    response.data.locks.forEach(hierarchyId => {
                        const hierarchy = this.hierarchies.find(item => item.hierarchy_id === hierarchyId);
                        if (hierarchy) {
                            this.selectedHierarchies.push(hierarchy);
                        }
                    });
                })
                .catch(() => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: this.$t('api-error')
                    });
                })
                .finally(() => this.hideLoader());
        },

        update() {
            this.showLoader();
            const data = {
                path: this.mediaItem.path,
                hierarchy_lock: this.restricted ? this.selectedHierarchies.map(item => item.hierarchy_id) : []
            };
            MediaApiService.updatePermissions(data).then(() => {
                this.$eventBus.$emit(EVENT_MEDIA_RESTRICT_CHANGED, {
                    path: this.mediaItem.path,
                    restricted: data.hierarchy_lock.length > 0
                });
                this.$swal.fire({
                    icon: "success",
                    html: this.$t('components.media.restrict-modal.success')
                });
            }).catch(() => {
                this.$swal.fire({
                    icon: "error",
                    allowOutsideClick: false,
                    html: this.$t('whoops')
                });
            }).finally(() => this.hideLoader());
        },

        showLoader() {
            return new Promise(resolve => {
                if (!empty(this.loader)) {
                    this.loader.hide();
                    this.loader = null;
                }
                this.loader = this.$loading.show({
                    container: this.$refs.loadingContainer,
                    isFullPage: false
                });
                resolve(this.loader);
            });
        },

        hideLoader() {
            return new Promise(resolve => {
                if (!empty(this.loader)) {
                    this.loader.hide();
                    this.loader = null;
                }
                resolve();
            });
        },
    },

    watch: {
        'mediaItem': function (value) {
            if (value) {
                this.fetch();
            }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99998;
}

.modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    margin: 15px auto 15px auto;
    height: calc(100vh - 50px);
    width: calc(100vw - 60vw);
    z-index: 99999;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #b89453;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 152px);
}

.btn-close {
    border: none;
    font-size: 36px;
    cursor: pointer;
    font-weight: bold;
    color: #b89453;
    background: transparent;
}
</style>
